import Calendar from '../Scheduler/Calendar';
import SelectedSlotChips from '../Scheduler/SelectedSlotChips';
import useCalendarFormFields from '../../hooks/appointments/useCalendarFormFields';
import {
  MAX_OFFERED_SLOTS,
  toggleOfferedSlot,
} from '../../utils/form/offeredSlots';

interface OfferTimesInputProps {
  appointmentLengthInMinutes: string | undefined;
  offeredSlots: string[];
  onChange: (starts: string[]) => void;
  helperText?: string;
  error?: string;
  disabled?: boolean;
}

function OfferTimesInput({
  appointmentLengthInMinutes,
  offeredSlots,
  onChange,
  helperText,
  error,
  disabled = false,
}: OfferTimesInputProps) {
  const { employeeId, serviceCategory, timezone } = useCalendarFormFields();

  return (
    <div className="calendar-input">
      <Calendar
        name="offeredSlots"
        label={`Times to offer (up to ${MAX_OFFERED_SLOTS}) *`}
        employeeId={employeeId}
        error={error}
        // Availability is length-dependent, so no default here: the
        // calendar refuses to open until a length is picked
        appointmentLengthInMinutes={appointmentLengthInMinutes || ''}
        startDateTime=""
        selectedDateTimes={offeredSlots}
        maxSelections={MAX_OFFERED_SLOTS}
        onChange={value =>
          onChange(toggleOfferedSlot(offeredSlots, value.toISOString()))
        }
        key={`${employeeId}-offer-times`}
        disabled={disabled}
        serviceCategory={serviceCategory}
        timezone={timezone}
      />
      <SelectedSlotChips
        starts={offeredSlots}
        appointmentLengthInMinutes={appointmentLengthInMinutes}
        timezone={timezone}
        helperText={helperText}
        onDelete={start => onChange(toggleOfferedSlot(offeredSlots, start))}
      />
    </div>
  );
}

export default OfferTimesInput;
